<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('QiYeZhanShi')">企业展示</a></li> -->
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('FaZhanLiCheng')">发展历程</a></li> -->
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">企业荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiZiZhi')">公司资质</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ChengGongAnLi')">典型案例</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('DangJianGongHui')">党建工会</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeHuaCe')">企业画册</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeXuanChuanPian')">企业宣传片</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="article_list">
                        <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.id"><span class="title"><a href="javascript:void(0);" @click.stop="article_view(article.id)"><i class="icon icon_arrow"></i>{{ article.webTitle }}</a></span><span class="date">{{ article.createTime }}</span></li>
                        </ul>
                    </div>
                    <div class="page">
                        <span>总共 {{ total_page }} 页，当前第 {{ pageNum }} 页</span>
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')" v-if="page_pre == 1">上一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')" v-if="page_next == 1">下一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { ChengGongAnLi } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '污水项目案例',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            //翻页
            pageNum: 1, //当前页
            pageSize: 10, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            // jump_page : '', //跳转页面默认值

            article_list:[
            {
                    id: '57',
                    webTitle: '哈尔滨市呼兰区孟家乡人民政府',
                    createTime: '',
                },
                {
                    id: '56',
                    webTitle: '哈尔滨市呼兰区腰堡街道办事处',
                    createTime: '',
                },
            ],
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        //this.ChengGongAnLi_data( this.pageNum, this.pageSize );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        article_view( id ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "ArticleView",
                query: { id: id, webType: 104, url: this.$route.path, title: this.title },
            });
        },
        page(e) {
            //分页参数
            if( e == "first" ){
                //首页
                this.ChengGongAnLi_data(
                    1,
                    this.pageSize,
                );
            } else if ( e == "pre" ) {
                //上一页
                this.ChengGongAnLi_data(
                    this.pageNum - 1,
                    this.pageSize,
                );
            } else if ( e == "next" ) {
                //下一页
                this.ChengGongAnLi_data(
                    this.pageNum + 1,
                    this.pageSize,
                );
            } else if( e == "last" ){
                //尾页
                this.ChengGongAnLi_data(
                    this.total_page,
                    this.pageSize,
                );
            };
        },
        ChengGongAnLi_data( pageNum, pageSize ){ //文章分类显示
            ChengGongAnLi({
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                //console.log( res );
                this.article_list = res.rows;
                //翻页
                this.pageNum = pageNum; //当前页
                this.total = res.total; //总数据

                this.total_page = Math.ceil( res.total / this.pageSize );

                if( this.pageNum < this.total_page && this.pageNum == 1){
                    this.page_pre = 0;
                    this.page_next = 1;
                } else if ( this.pageNum == this.total_page && this.pageNum !== 1 ) {
                    this.page_pre = 1;
                    this.page_next = 0;
                } else if ( this.pageNum == this.total_page && this.total_page == 1 ) {
                    this.page_pre = 0;
                    this.page_next = 0;
                }else{
                    this.page_pre = 1;
                    this.page_next = 1;
                };

            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ChengGongAnLi3.vue